<template lang="pug">
    div
        .form__title
            slot(name='title')
        form.form__body(action='javascript://' v-if='params')
            slot(name='multiplayer')
            template(v-if='!homework || homework.editable === undefined || (homework && (homework.editable || usersIds))')
                .form__field
                    label.form__label
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_numOfExamples') }}
                    .form__field-body.form-container__select-examples
                        cs-spin-input(
                            :value="params.amountOfExamples",
                            :max="amountOfExamples",
                            :min="1",
                            :disabled="(params && (params.infinityAmountOfExamples || !!params.timeLimit)) || !!params.date",
                            @increase="increaseExamples",
                            @decrease="decreaseExamples",
                            @input="params.amountOfExamples = $event",
                        )
                        .form-container__select-infinity-mode(v-if="gameMode && gameMode === 'free-game'")
                            cs-checkbox#infinityAmountOfExamples.form-container__checkbox(
                                v-model="params.infinityAmountOfExamples"
                                :checked="params && params.infinityAmountOfExamples"
                                :disabled="(params && !!params.timeLimit) || (params && !!params.date)"
                            )
                            svg-icon.form-container__svg-icon(name="infinity" :aria-hidden="true" size="big")
                .form__field(v-if="gameMode  !==  'generator-settings'")
                    label.form__label
                        |  {{  $i18n.t('trainer.trainer_gameFormSetting_timeToAnswer')  }}
                    .form__field-body
                        cs-multiselect(
                            :options="amountOfSeconds()",
                            v-model="params.timeForAnswer"
                            :placeholder="secondsLabel(params.timeForAnswer)"
                            :multiple="false"
                            :allow-empty="false"
                            :custom-label="secondsLabel"
                            :disabled="!!params.timeLimit"
                        )
                .form__field
                    label.form__label
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_timeLimit') }}
                    .form__field-body
                        cs-multiselect(
                            :options="timeLimitValues",
                            v-model="params.timeLimit"
                            :placeholder="timeLimitLabel(params.timeLimit)"
                            :multiple="false"
                            :custom-label="timeLimitLabel"
                            :disabled="params.timeForAnswer !== -1"
                        )
                .form__field(v-if="user.type !== 'student' && !params.randomDate && params.amountOfExamples === 1")
                    label.form__label
                        | {{ $i18n.t('trainer.trainer_gameForm_chooseDate') }}
                    .form__field-body
                        cs-datepicker(
                            :disabledDates="disabledDates()"
                            :format="customFormatter",
                            @input="params.date = dateToMoment($event, 'DD.MM.YYYY')"
                            :value="dateStringToDate()"
                        )
                .form__field
                    label.form__label
                        | {{ $i18n.t('trainer.trainer_gameForm_randomDate') }}
                    .form__field-body
                        cs-checkbox(
                            v-model="params.randomDate"
                        )
                .form__field(v-if="params.randomDate")
                    label.form__label
                        | {{ $i18n.t('trainer.trainer_gamePlayBox_leapYear') }}
                    .form__field-body
                        cs-checkbox(
                            v-model="params.isLeapYear"
                        )
            slot(name='parameters')
            slot(name='help')
            .buttons-container
                template(v-if='!usersIds')
                    cs-button.form__button(type="button", pattern="primary-outline" color="blue" @click='cancel')
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_dontSave') }}
                    template(v-if="gameMode && gameMode === 'free-game'")
                        cs-button.form__button(type="button", color="blue" @click='saveGameMode', :disabled="!(params.randomDate || params.date)")
                            | {{ $i18n.t('trainer.trainer_gameFormSetting_saveGame') }}
                    template(v-else='')
                        cs-button.form__button(type="button", color="blue" @click='saveGame', :disabled="!(params.randomDate || params.date)")
                            | {{ $i18n.t('trainer.trainer_gameFormSetting_saveGame') }}
                template(v-else='')
                    cs-button.form__button(type="button", pattern="primary-outline" color="blue" @click='cancel')
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_dontSave')}}
                    cs-button.form__button(type="button", color="blue" @click='saveGame')
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_saveDifference') }}
</template>

<script>
    import _ from 'lodash';
    import { mapState } from 'vuex';
    import TrainerGames from '../../../config/trainer';
    import GameFormMixin from '../../../utils/trainer/GameFormMixin';
    import { getInitParameters } from '../../../utils/trainer/getInitParameters';
    const DEFAULT_TIME_LIMIT = 0;
    import multiplayerFormMixin from '../../../utils/multiplayer/formMixin';
    import combiningCapacitiesMixin from '../utils/combiningCapacitiesMixin';

    import IntervalConfig from '../../trainer/configs/IntervalConfig';
    import moment from 'moment';

    export default {
        props: [
            'slug',
            'courseType',
            'id',
            'usersIds',
            'homeworkId',
            'gameMode',
            'levelAnswerDuration',
            'gameId',
            'generatorSettings',
            'generatorGameIndex',
        ],
        data() {
            return {
                amountOfExamples: 100,
                amountOfActions: 10,
                timeLimitValues: IntervalConfig.timeLimitValues,
                params: null,
                games: _.cloneDeep(TrainerGames.games),
            };
        },
        mixins: [GameFormMixin, multiplayerFormMixin, combiningCapacitiesMixin],
        mounted() {
            if (this.gameMode === 'free-game') {
                let paramsArray = this.$store.state.trainer.paramsArray;
                if (paramsArray && paramsArray[0] && paramsArray[0].slug === this.slug) {
                    this.paramsArray = _.cloneDeep(paramsArray);
                    this.$emit('playersNumber', this.paramsArray.length);
                    this.params = this.paramsArray[0];
                } else if (this.gamesParameters) {
                    this.$set(
                        this,
                        'params',
                        getInitParameters({
                            slug: this.slug,
                            parameters: {
                                default: _.cloneDeep(this.gamesParameters[this.slug]),
                            },
                        })
                    );
                } else {
                    _.cloneDeep(TrainerGames.games).forEach(item => {
                        if (item.slug === this.slug) {
                            this.params = item.parameters.default;
                        }
                    });
                }
                this.selectedDifficult = _.find(this.difficult, { name: this.params.difficult });
                this.params.infinityAmountOfExamples = true;
            } else {
                this.setInitParams(this.getKey(this.usersIds));
            }
        },
        watch: {
            'params.randomDate'(val) {
                if (val) {
                    this.params.date = null;
                }
            },
            'params.date'(val) {
                if (val) {
                    this.params.infinityAmountOfExamples = false;
                    this.params.amountOfExamples = 1;
                }
            },
            'params.amountOfExamples'(val) {
                if (val) {
                    this.params.timeLimit = DEFAULT_TIME_LIMIT;
                }
            },
        },
        computed: {
            ...mapState({
                homework: state => state.trainer.homework,
                gamesParameters: state => state.trainer.gamesParameters,
                user: state => state.auth.user,
            }),
        },
        methods: {
            dateStringToDate() {
                if (this.params.date) {
                    let dateParts = this.params.date.split('.');
                    return new Date(dateParts[2], parseInt(dateParts[1]) - 1, dateParts[0]);
                }
            },
            dateToMoment(date, format) {
                return moment(date).format(format);
            },
            customFormatter(date) {
                return moment(date).format('D MMM YYYY');
            },
            disabledDates() {
                return {
                    to: new Date(1600, 1, 1),
                };
            },
            decreaseExamples() {
                if (
                    this.params.amountOfExamples !== 1 &&
                    !this.params.timeLimit &&
                    !this.params.infinityAmountOfExamples
                ) {
                    this.params.amountOfExamples -= 1;
                }
            },
            increaseExamples() {
                if (
                    this.params.amountOfExamples !== this.amountOfExamples &&
                    !this.params.timeLimit &&
                    !this.params.infinityAmountOfExamples
                ) {
                    this.params.amountOfExamples += 1;
                }
            },
            secondsLabel(amount) {
                if (!this.params.dictation) {
                    return amount === -1
                        ? this.$i18n.t('trainer.trainer_gameFormSettingValue_off')
                        : amount + ' ' + this.$i18n.t('trainer.trainer_gameFormSettingValue_seconds');
                }
                return amount + ' ' + this.$i18n.t('trainer.trainer_gameFormSettingValue_seconds');
            },
            amountOfSeconds() {
                if (!this.params.dictation) {
                    let array = Array.from(Array(100), (_, i) => i + 1);
                    array.unshift(Number('-1'));
                    return array;
                }
                return Array.from(Array(100), (_, i) => i + 1);
            },
            timeLimitLabel(amount) {
                return amount === 0
                    ? this.$i18n.t('trainer.trainer_gameFormSettingValue_off')
                    : amount + ' ' + this.$i18n.t('trainer.trainer_gameFormSettingValue_minutes');
            },
        },
    };
</script>

<style lang="scss" scoped>
    .form__title {
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        text-align: center;
        margin-bottom: 25px;
    }

    .form__body {
        width: 100%;
        max-width: 1020px;
        margin: 0 auto;
        box-sizing: border-box;
    }

    .form__field {
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;
        @include media($md) {
            padding: 0 2.5px;
            flex-direction: row;
            align-items: center;
        }
        @include media($lg) {
            padding: 0 10%;
        }
        @include media($xlg) {
            padding: 0 13%;
        }
    }
    .form__label {
        min-width: 0;
        font-size: 16px;
        line-height: 19px;
        margin-right: 20px;
        margin-bottom: 0.5rem;
        @include media($md) {
            width: 8em;
            margin-bottom: 0;
            text-align: right;
        }
        @include media($xlg) {
            max-width: none;
            min-width: 13em;
        }
    }
    .form__field-body {
        flex-grow: 5;
    }

    .form-container__select {
        width: 100%;
        max-width: 220px;
        @media screen and (max-width: 767px) {
            max-width: none;
        }
        @include media($xl) {
            max-width: 280px;
        }
    }

    .form-container__select-examples {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        @media screen and (min-width: 700px) {
            flex-direction: row;
            align-items: center;
        }
    }

    .form-container__select-infinity-mode {
        display: flex;
        align-items: center;
        margin-top: 20px;
        @media screen and (min-width: 700px) {
            margin-top: 0;
        }
    }

    .form-container__checkbox {
        margin-left: 30px;
    }

    .form-container__svg-icon {
        opacity: 0.7;
        margin: 0 10px 10px 0;
    }

    .filter-capacities__field {
        width: 50%;
    }

    .filter-capacities__field-body {
        display: flex;
        flex-wrap: wrap;
        .cs-checkbox {
            margin-right: 20px;
        }
    }

    .buttons-container {
        display: flex;
        justify-content: center;
        margin: 20px;
        flex-direction: column;
        @include media($sm) {
            flex-direction: row;
        }
    }

    .form__button {
        margin: 10px;
        @include media($md) {
            margin: 0 10px;
        }
    }

    .checkbox {
        @media screen and (max-width: 767px) {
            flex-direction: row;
            align-items: center;
            flex-wrap: nowrap;
        }
    }

    .checkbox__label {
        @media screen and (max-width: 767px) {
            margin-bottom: 0;
            display: flex;
            align-items: center;
        }
    }
</style>
